
import Flickity from 'flickity';


const initLogosBlock = (): void => {
    document.querySelectorAll('.tv-logos__container').forEach((carousel) => {
        let requestId: number;

        if (carousel.childNodes.length > 3) {
            const flkty = new Flickity(carousel, {
                accessibility: true,
                resize: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                percentPosition: true,
                setGallerySize: true,
                cellAlign: 'left',
                imagesLoaded: false,
                autoPlay: false,
            });

            // Set initial position to be 0
            // @ts-ignore
            flkty.x = 0;

            // Main function that 'plays' the marquee.
            const play = (): void => {
                // @ts-ignore
                flkty.x = flkty.x - 1.5;
                // @ts-ignore
                flkty.settle(flkty.x);
                requestId = window.requestAnimationFrame(play);
            }

            // Main function to cancel the animation.
            // const pause = (): void => {
            //     if (requestId) {
            //         window.cancelAnimationFrame(requestId)
            //         requestId = undefined;
            //     }
            // }

            // Start the marquee animation
            play();

            // // Pause on mouse over / focusin
            // carousel.addEventListener('mouseover', pause, false);
            // carousel.addEventListener('focusin', pause, false);

            // // Unpause on mouse out / focusout
            // carousel.addEventListener('mouseout', play, false);
            // carousel.addEventListener('focusout', play, false);

        }

    });
}

export default initLogosBlock;